import React from "react";
import Banners from "../../Components/banners";

const BottomBanners = ({ data, col }) => {
  return <Banners data={data} col={col} />;
};

export default BottomBanners;

